<template>
  <div class="tan_needGz_portrait_botZheContWrap" v-if="newAllData">
    <div class="refer_comLine_heng"></div>
    <div class="txjyWrap mt15" style="width: 780px;">
      <div class="refer_comTit2 border_no paddindNo heightAuto" style="width:750px;display:block;" v-if="newAllData.descLabel" v-html="$options.filters.reMate(newAllData.descLabel)"></div>
      <div class="zxWrap" v-if=true>
        <div class="zxLine">
          <div class="zxCirWrap" :key="index" v-for="(item,index) in newAllData.data">
            <div class="zxCir">
              <img class="red_cir_noSel" src="../../../assets/red_cir_noSel.png" alt="">
              <img class="red_cir_noSel red_cir_Sel" src="../../../assets/red_cir_Sel.png" alt="">
              <div class="zxCirFloWin">
                <img class="ai_image_change_triangle_d" src="../../../assets/ai_image_change_triangle_d@2x.png" alt="">
                <div class="time">{{item.date}}</div>
                <div class="flex_alignCen">
                  <div class="tCir"></div>
                  <div class="time" v-if="item.value">{{ item.value }}</div>
                  <div class="time mr10" v-if="type == 'lcSdt' && item.time">{{ item.time }}</div>
                  <div class="time" v-if="(type == 'lcscfb' || type == 'lcSdt')&& item.duration">{{ item.duration }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  
</template>

<script>
import portFn from "../../../utils/PortraitFunction.js";
import CustomRichText from "../../../utils/CustomRichText.js";

export default {
  components: {},
  filters: {
    reMate(val) {
      return CustomRichText.reMate(portFn.function_reg_str_to_arr(val));
    },
  },
  props: {
    haveChangeData: null,
    datatype: null,
  },
  watch: {
    haveChangeData(newVal, oldVal) {
      this.newAllData = newVal;
      this.newAllData.data = this.newAllData.data.reverse()
      // console.log("进入了haveChange组件 且有变化了");
      console.log(this.newAllData);
    },
    datatype(newVal, oldVal) {
      this.type = newVal || '';
      // console.log("进入了haveChange组件 且有变化了");
      console.log(this.newAllData);
    },
  },
  data() {
    return {
      newAllData: null,
      type: null,         // 离床时长分布 lcscfb    离床散点图 lcSdt
    };
  },
  created() {},
  mounted() {
    this.newAllData = this.haveChangeData;
    this.newAllData.data = this.newAllData.data.reverse()
    this.type = this.datatype || '';
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.tan_needGz_portrait_botZheContWrap ::v-deep {
  .refer_comLine_heng{
    width: 780px;
    height: 1px;
    opacity: 0.1;
    border: 1px solid #1F2635;
    margin-top: 15px;
  }
  .txjyWrap {
    width: 810px;
    height: auto;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid rgba(255, 113, 134, 0.5);
    padding: 15px;
    box-sizing: border-box;
    display: block;
    .txjyTit {
      width: 356px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1f2635;
      margin-left: 14px;
      position: relative;
    }
    .txjyTit::after {
      width: 4px;
      height: 14px;
      background: #ff7186;
      border-radius: 2px;
      content: "";
      position: absolute;
      left: -14px;
      top: 5px;
    }
    .txjyTit_after_blue::after {
      background: #1890ff;
    }
    .txjyTit2 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9094a6;
      line-height: 20px;
      margin-top: 10px;
    }
    .refer_comTit {
      width: 780px;
      height: auto;
      background: #f3f4f7;
      border-radius: 4px;
      padding: 12px;
      box-sizing: border-box;

      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5e6779;
      position: relative;
    }
    .refer_comTit::after {
      content: "";
      width: 0px;
      height: 0px;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 12px solid #f3f4f7;
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }
    .refer_comLine_heng {
      width: 780px;
      height: 1px;
      opacity: 0.1;
      border: 1px solid #1f2635;
      margin-top: 15px;
    }
    .refer_comTit2 {
      width: 780px;
      height: 52px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1f2635;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(255, 113, 134, 0.5);
      padding: 0 15px;
      box-sizing: border-box;
      // display: flex;
      align-items: center;
      .reIcon {
        width: 15px;
        height: 15px;
        // margin-right: 5px;
      }
    }
    .fer_txjyWrap {
      width: 780px;
      height: auto;
      background: #f3f4f7;
      border-radius: 4px;
      padding: 0 15px 15px 15px;
      .fer_txjy {
        width: 750px;
        height: 46px;
        border: 0;
        border-bottom: 1px solid #e8eaee;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9094a6;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      .fer_txjyIcon {
        width: 14px;
        height: 14px;
      }
    }
    .lcTimeTip {
      display: flex;
      justify-content: center;
      align-items: center;
      .lcTimeKuang {
        width: 16px;
        height: 5px;
        background: #e0ecfc;
      }
      .lcTimeFont {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a5a9bc;
      }
    }
    .lcscSinWrap {
      width: 780px;
      height: auto;
      background: #f8f8fc;
      border-radius: 8px;
      padding: 12px 15px;
      box-sizing: border-box;
      .name {
        width: 96px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a5a9bc;
      }
      .boxBg {
        width: 750px;
        height: 8px;
        border-radius: 6px;
      }
      .boxBgData {
        width: 750px;
        height: 20px;
        display: flex;
        margin-top: 4px;
        .bNum {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #a5a9bc;
          margin-left: 67.5px;
          position: relative;
        }
        .bNum:nth-of-type(1) {
          margin-left: 0;
        }
      }
    }
    .zxSanWrap {
      display: flex;
      align-items: center;
      justify-content: center;
      .zxSanList {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a5a9bc;
        padding-left: 22px;
        box-sizing: border-box;
        position: relative;
      }
      .zxSanList::after {
        content: "";
        width: 6px;
        height: 6px;
        background: #ff7186;
        border-radius: 50%;
        position: absolute;
        left: 12px;
        top: 6px;
      }
      .zxSanList:nth-of-type(2):after {
        background: #ffb971;
      }
      .zxSanList:nth-of-type(3):after {
        background: #44d7b6;
      }
      .zxSanList:nth-of-type(4):after {
        background: #1890ff;
      }
    }
    .zxSanBotCont {
      width: 780px;
      height: auto;
      padding: 15px;
      box-sizing: border-box;
      background: #f3f4f7;
      border-radius: 4px;
      position: relative;
      .zxSanBotListWrap {
        display: flex;
        .zxSanBotList {
          width: 180px;
          height: 73px;
          background: #ffffff;
          border-radius: 4px;
          margin-left: 10px;
          .zxBoxBlock {
            width: 16px;
            height: 5px;
            background: #ffd4da;
          }
          .zxBoxName {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #a5a9bc;
          }
        }
        .zxSanBotList:nth-of-type(1) {
          margin-left: 0;
        }
      }
    }
    .zxSanBotCont::after {
      content: "";
      width: 0px;
      height: 0px;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 12px solid #f3f4f7;
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .fer_txjyWrap {
    width: 780px;
    height: auto;
    background: #f3f4f7;
    border-radius: 4px;
    padding: 0 15px 15px 15px;
    .fer_txjy {
      width: 750px;
      height: 46px;
      border: 1px solid #e8eaee;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9094a6;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
    .fer_txjyIcon {
      width: 14px;
      height: 14px;
    }
  }
}
</style>
